export default "__VITE_ASSET__BHd50e6m__"